var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "simple-form flex col-3" }, [
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(1),
          _vm._v(" "),
          _c("div", { staticClass: "form-value width-2x" }, [
            _c("span", [_vm._v(_vm._s(_vm.contract.fstPartyName))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(2),
          _vm._v(" "),
          _c("div", { staticClass: "form-value width-2x" }, [
            _c("span", [_vm._v(_vm._s(_vm.contract.sndPartyName))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(3),
          _vm._v(" "),
          _c("div", { staticClass: "form-value width-2x" }, [
            _c("span", [_vm._v(_vm._s(_vm.contract.title))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(4),
          _vm._v(" "),
          _c("div", { staticClass: "form-value width-2x" }, [
            _c("span", [_vm._v(_vm._s(_vm.contract.no))])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "simple-form flex col-3" }, [
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(5),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value width-2x" },
            [
              _c("el-date-picker", {
                staticClass: "width-2x",
                attrs: {
                  disabled: true,
                  type: "date",
                  "value-format": "yyyy-MM-dd",
                  placeholder: "选择日期"
                },
                model: {
                  value: _vm.contract.dateStart,
                  callback: function($$v) {
                    _vm.$set(_vm.contract, "dateStart", $$v)
                  },
                  expression: "contract.dateStart"
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(6),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value width-2x" },
            [
              _c("el-date-picker", {
                staticClass: "width-2x",
                attrs: {
                  type: "date",
                  "value-format": "yyyy-MM-dd",
                  placeholder: "选择日期"
                },
                on: { change: _vm.checkTime },
                model: {
                  value: _vm.contract.dateEnd,
                  callback: function($$v) {
                    _vm.$set(_vm.contract, "dateEnd", $$v)
                  },
                  expression: "contract.dateEnd"
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [
            _c("label", { class: _vm.normalFlag ? "required" : "" }, [
              _vm._v("税率(%)")
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value width-2x" },
            [
              _vm.normalFlag
                ? _c(
                    "el-select",
                    {
                      attrs: { filterable: "", placeholder: "请选择税率" },
                      on: {
                        change: function($event) {
                          _vm.taxRateChange(_vm.contract.taxRate)
                        }
                      },
                      model: {
                        value: _vm.contract.taxRate,
                        callback: function($$v) {
                          _vm.$set(_vm.contract, "taxRate", $$v)
                        },
                        expression: "contract.taxRate"
                      }
                    },
                    _vm._l(_vm.fiscalTaxMarkList, function(item) {
                      return _c("el-option", {
                        key: item.rate,
                        attrs: { label: item.rate, value: item.rate }
                      })
                    })
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.normalFlag
                ? _c("el-input", {
                    staticClass: "width-2x",
                    on: {
                      change: function($event) {
                        _vm.taxRateChange(_vm.contract.taxRate)
                      }
                    },
                    model: {
                      value: _vm.contract.taxRate,
                      callback: function($$v) {
                        _vm.$set(_vm.contract, "taxRate", $$v)
                      },
                      expression: "contract.taxRate"
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content-caption dashed" }, [
        _c("span", [_vm._v("发票信息")]),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "swb-btn swb-btn-link",
            on: { click: _vm.selectInvoiceSubject }
          },
          [_vm._v("常用发票")]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "simple-form flex col-2" }, [
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(7),
          _vm._v(" "),
          _c("div", { staticClass: "form-value width-2x" }, [
            _c(
              "ul",
              { staticClass: "enum-list" },
              _vm._l(_vm.invoiceTypeList, function(merchantInvoiceType) {
                return _c(
                  "li",
                  {
                    staticClass: "enum-item",
                    class: {
                      checked:
                        merchantInvoiceType.value == _vm.contract.invoiceType
                    },
                    on: {
                      click: function($event) {
                        _vm.checkInvoiceType(merchantInvoiceType.value)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(merchantInvoiceType.text)
                    ),
                    _c("i")
                  ]
                )
              })
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(8),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value width-2x" },
            [
              _c("el-input", {
                model: {
                  value: _vm.contract.invoiceTitle,
                  callback: function($$v) {
                    _vm.$set(_vm.contract, "invoiceTitle", $$v)
                  },
                  expression: "contract.invoiceTitle"
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(9),
          _vm._v(" "),
          _c("div", { staticClass: "form-value width-2x mt5" }, [
            _c(
              "ul",
              { staticClass: "enum-list" },
              _vm._l(_vm.invoiceContentTagList, function(invoiceContentTag) {
                return _c(
                  "li",
                  {
                    staticClass: "enum-item",
                    class: {
                      checked:
                        invoiceContentTag.name == _vm.contract.invoiceContentTag
                    },
                    on: {
                      click: function($event) {
                        _vm.checkinvoiceContentTag(invoiceContentTag.name)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(invoiceContentTag.name)
                    ),
                    _c("i")
                  ]
                )
              })
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(10),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value width-2x" },
            [
              _c("el-input", {
                model: {
                  value: _vm.contract.taxPayerNo,
                  callback: function($$v) {
                    _vm.$set(_vm.contract, "taxPayerNo", $$v)
                  },
                  expression: "contract.taxPayerNo"
                }
              })
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content-caption dashed" }, [
        _c("span", [_vm._v("适用机构(必选)")]),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "swb-btn swb-btn-link",
            on: { click: _vm.selectAppliedShop }
          },
          [_vm._v("选择")]
        )
      ]),
      _vm._v(" "),
      _vm._l(_vm.contract.contractAppliedShopList, function(
        contractAppliedShop,
        index
      ) {
        return _c(
          "el-tag",
          {
            key: contractAppliedShop.shopName,
            staticClass: "mr5",
            attrs: { closable: contractAppliedShop.id == null, type: "info" },
            on: {
              close: function($event) {
                _vm.deleteAppliedShop(index)
              }
            }
          },
          [_c("span", [_vm._v(_vm._s(contractAppliedShop.shopName))])]
        )
      }),
      _vm._v(" "),
      _vm._m(11),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-layout", staticStyle: { overflow: "auto" } },
        [
          _c(
            "el-form",
            { ref: "contractServcList", attrs: { model: _vm.contract } },
            [
              _c("table", { staticClass: "custom-tbl error-prompt" }, [
                _c("thead", { staticClass: "head" }, [
                  _c("tr", { staticClass: "row" }, [
                    _c(
                      "th",
                      {
                        staticClass: "text-align: left;",
                        attrs: { width: "200" }
                      },
                      [_vm._v("设备维保分组")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-align: left;",
                        attrs: { width: "150" }
                      },
                      [_vm._v("资产品牌")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-align: left;",
                        attrs: { width: "150" }
                      },
                      [_vm._v("服务类型")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-align: left;",
                        attrs: { width: "150" }
                      },
                      [_vm._v("商品分类")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-align: left;",
                        attrs: { width: "200" }
                      },
                      [_vm._v("服务内容")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-align: left;",
                        attrs: { width: "80" }
                      },
                      [_vm._v("仅部件报修")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-align: left;",
                        attrs: { width: "300" }
                      },
                      [_vm._v("设备部件")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-align: left;",
                        attrs: { width: "200" }
                      },
                      [_vm._v("服务项目")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-align: right;",
                        attrs: { width: "140" }
                      },
                      [_vm._v("上门费(元)")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-align: right;",
                        attrs: { width: "140" }
                      },
                      [_vm._v("服务费(元)")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-align: right;",
                        attrs: { width: "140" }
                      },
                      [_vm._v("要求响应时长(分钟)")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-align: right;",
                        attrs: { width: "140" }
                      },
                      [_vm._v("要求到达时长(分钟)")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-align: right;",
                        attrs: { width: "140" }
                      },
                      [_vm._v("要求维修时长(分钟)")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-align: right;",
                        attrs: { width: "120" }
                      },
                      [_vm._v("要求质保时长(天)")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-align: right;",
                        attrs: { width: "140" }
                      },
                      [_vm._v("电话回询时限(分钟)")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-align: right;",
                        attrs: { width: "200" }
                      },
                      [_vm._v("服务次数")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-align: left;",
                        attrs: { width: "200" }
                      },
                      [_vm._v("操作")]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  { staticClass: "body" },
                  _vm._l(_vm.contract.contractServcList, function(item, index) {
                    return _c("tr", { staticClass: "row" }, [
                      _c("td", [
                        _c("span", { staticClass: "fl" }, [
                          _vm._v(_vm._s(item.devcGroupFullName || ""))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("span", { staticClass: "fl" }, [
                          _vm._v(_vm._s(item.innerDevcBrandName || ""))
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { disabled: true },
                              model: {
                                value: item.servcTypeId,
                                callback: function($$v) {
                                  _vm.$set(item, "servcTypeId", $$v)
                                },
                                expression: "item.servcTypeId"
                              }
                            },
                            _vm._l(_vm.servcTypeList, function(servcType) {
                              return _c("el-option", {
                                key: servcType.value,
                                attrs: {
                                  label: servcType.text,
                                  value: servcType.value
                                }
                              })
                            })
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("td", [
                        _c("span", { staticClass: "fl" }, [
                          _vm._v(_vm._s(item.goodsCatName || ""))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("span", { staticClass: "fl" }, [
                          _vm._v(_vm._s(item.servcSpec || ""))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("span", { staticClass: "fl" }, [
                          _vm._v(_vm._s(item.devcPartsOnly || ""))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("span", { staticClass: "fl" }, [
                          _vm._v(_vm._s(item.devcParts || ""))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("span", { staticClass: "fl" }, [
                          _vm._v(_vm._s(item.title || ""))
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _vm.checkActionPerm("view_item_price")
                            ? _c("el-input", {
                                attrs: {
                                  type: "number",
                                  min: 0,
                                  disabled: true
                                },
                                model: {
                                  value: item.toDoorFee,
                                  callback: function($$v) {
                                    _vm.$set(item, "toDoorFee", $$v)
                                  },
                                  expression: "item.toDoorFee"
                                }
                              })
                            : _c("el-input", {
                                attrs: {
                                  disabled: "",
                                  type: "text",
                                  value: "没有权限"
                                }
                              })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _vm.checkActionPerm("view_item_price")
                            ? _c("el-input", {
                                attrs: {
                                  type: "number",
                                  min: 0,
                                  disabled: true
                                },
                                model: {
                                  value: item.price,
                                  callback: function($$v) {
                                    _vm.$set(item, "price", $$v)
                                  },
                                  expression: "item.price"
                                }
                              })
                            : _c("el-input", {
                                attrs: {
                                  disabled: "",
                                  type: "text",
                                  value: "没有权限"
                                }
                              })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c("el-input", {
                            attrs: { type: "number", min: 0, disabled: true },
                            model: {
                              value: item.rspTimeMi,
                              callback: function($$v) {
                                _vm.$set(item, "rspTimeMi", _vm._n($$v))
                              },
                              expression: "item.rspTimeMi"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c("el-input", {
                            attrs: { type: "number", min: 0, disabled: true },
                            model: {
                              value: item.arriveTimeMi,
                              callback: function($$v) {
                                _vm.$set(item, "arriveTimeMi", _vm._n($$v))
                              },
                              expression: "item.arriveTimeMi"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c("el-input", {
                            attrs: { type: "number", min: 0, disabled: true },
                            model: {
                              value: item.repairedTimeMi,
                              callback: function($$v) {
                                _vm.$set(item, "repairedTimeMi", _vm._n($$v))
                              },
                              expression: "item.repairedTimeMi"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c("el-input", {
                            attrs: { type: "number", min: 0, disabled: true },
                            model: {
                              value: item.wrntPeriod,
                              callback: function($$v) {
                                _vm.$set(item, "wrntPeriod", _vm._n($$v))
                              },
                              expression: "item.wrntPeriod"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c("el-input", {
                            attrs: { type: "number", min: 0, disabled: true },
                            model: {
                              value: item.telCallTimeMi,
                              callback: function($$v) {
                                _vm.$set(item, "telCallTimeMi", _vm._n($$v))
                              },
                              expression: "item.telCallTimeMi"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { disabled: true },
                              model: {
                                value: item.timesLimitType,
                                callback: function($$v) {
                                  _vm.$set(item, "timesLimitType", $$v)
                                },
                                expression: "item.timesLimitType"
                              }
                            },
                            _vm._l(_vm.timesLimitTypeList, function(
                              timesLimitType
                            ) {
                              return _c("el-option", {
                                key: timesLimitType.value,
                                attrs: {
                                  label: timesLimitType.text,
                                  value: timesLimitType.value
                                }
                              })
                            })
                          ),
                          _vm._v(" "),
                          item.timesLimitType == 0
                            ? [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      prop:
                                        "contractServcList." +
                                        index +
                                        ".quantity",
                                      rules: {
                                        validator: _vm.quantityCheck,
                                        trigger: "blur"
                                      }
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        type: "number",
                                        min: 0,
                                        disabled: !item.quantityRevisible
                                      },
                                      on: {
                                        change: function($event) {
                                          _vm.quantityChange(index, false)
                                        }
                                      },
                                      model: {
                                        value: item.quantity,
                                        callback: function($$v) {
                                          _vm.$set(
                                            item,
                                            "quantity",
                                            _vm._n($$v)
                                          )
                                        },
                                        expression: "item.quantity"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            : _vm._e()
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("td", [
                        _c(
                          "div",
                          {
                            staticClass: "swb-btn swb-btn-link",
                            on: {
                              click: function($event) {
                                _vm.setOrgSpecInfo(
                                  index,
                                  item.servcTypeId,
                                  item.timesLimitType,
                                  item.quantityRevisible,
                                  false
                                )
                              }
                            }
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  item.timesLimitType != 1
                                    ? "设置特定门店价格"
                                    : "设置门店次数和价格"
                                )
                              )
                            ])
                          ]
                        )
                      ])
                    ])
                  })
                )
              ])
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm._m(12),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-layout", staticStyle: { overflow: "auto" } },
        [
          _c(
            "el-form",
            { ref: "contractServc2List", attrs: { model: _vm.contract } },
            [
              _c("table", { staticClass: "custom-tbl error-prompt" }, [
                _c("thead", { staticClass: "head" }, [
                  _c("tr", { staticClass: "row" }, [
                    _c(
                      "th",
                      {
                        staticClass: "text-align: left;",
                        attrs: { width: "150" }
                      },
                      [_vm._v("服务类型")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-align: left;",
                        attrs: { width: "200" }
                      },
                      [_vm._v("常规服务需求")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-align: left;",
                        attrs: { width: "200" }
                      },
                      [_vm._v("服务内容")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-align: left;",
                        attrs: { width: "200" }
                      },
                      [_vm._v("服务项目")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-align: right;",
                        attrs: { width: "140" }
                      },
                      [_vm._v("上门费(元)")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-align: right;",
                        attrs: { width: "140" }
                      },
                      [_vm._v("服务费(元)")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-align: right;",
                        attrs: { width: "140" }
                      },
                      [_vm._v("要求响应时长(分钟)")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-align: right;",
                        attrs: { width: "140" }
                      },
                      [_vm._v("要求到达时长(分钟)")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-align: right;",
                        attrs: { width: "140" }
                      },
                      [_vm._v("要求维修时长(分钟)")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-align: right;",
                        attrs: { width: "120" }
                      },
                      [_vm._v("要求质保时长(天)")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-align: right;",
                        attrs: { width: "140" }
                      },
                      [_vm._v("电话回询时限(分钟)")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-align: right;",
                        attrs: { width: "200" }
                      },
                      [_vm._v("服务次数")]
                    ),
                    _vm._v(" "),
                    _c("th", { attrs: { width: "150" } }, [_vm._v("操作")])
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  { staticClass: "body" },
                  _vm._l(_vm.contract.contractServc2List, function(
                    item,
                    index
                  ) {
                    return _c("tr", { staticClass: "row" }, [
                      _c(
                        "td",
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { disabled: true },
                              model: {
                                value: item.servcTypeId,
                                callback: function($$v) {
                                  _vm.$set(item, "servcTypeId", $$v)
                                },
                                expression: "item.servcTypeId"
                              }
                            },
                            _vm._l(_vm.servcTypeList, function(servcType) {
                              return _c("el-option", {
                                key: servcType.value,
                                attrs: {
                                  label: servcType.text,
                                  value: servcType.value
                                }
                              })
                            })
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("td", [
                        _c("span", { staticClass: "fl" }, [
                          _vm._v(_vm._s(item.comnRequireTitle || ""))
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              rows: 2,
                              disabled: true
                            },
                            model: {
                              value: item.servcSpec,
                              callback: function($$v) {
                                _vm.$set(item, "servcSpec", $$v)
                              },
                              expression: "item.servcSpec"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("td", [
                        _c("span", { staticClass: "fl" }, [
                          _vm._v(_vm._s(item.title || ""))
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _vm.checkActionPerm("view_item_price")
                            ? _c("el-input", {
                                attrs: {
                                  type: "number",
                                  min: 0,
                                  disabled: true
                                },
                                model: {
                                  value: item.toDoorFee,
                                  callback: function($$v) {
                                    _vm.$set(item, "toDoorFee", $$v)
                                  },
                                  expression: "item.toDoorFee"
                                }
                              })
                            : _c("el-input", {
                                attrs: {
                                  disabled: "",
                                  type: "text",
                                  value: "没有权限"
                                }
                              })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _vm.checkActionPerm("view_item_price")
                            ? _c("el-input", {
                                attrs: {
                                  type: "number",
                                  min: 0,
                                  disabled: true
                                },
                                model: {
                                  value: item.price,
                                  callback: function($$v) {
                                    _vm.$set(item, "price", $$v)
                                  },
                                  expression: "item.price"
                                }
                              })
                            : _c("el-input", {
                                attrs: {
                                  disabled: "",
                                  type: "text",
                                  value: "没有权限"
                                }
                              })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c("el-input", {
                            attrs: { type: "number", min: 0, disabled: true },
                            model: {
                              value: item.rspTimeMi,
                              callback: function($$v) {
                                _vm.$set(item, "rspTimeMi", _vm._n($$v))
                              },
                              expression: "item.rspTimeMi"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c("el-input", {
                            attrs: { type: "number", min: 0, disabled: true },
                            model: {
                              value: item.arriveTimeMi,
                              callback: function($$v) {
                                _vm.$set(item, "arriveTimeMi", _vm._n($$v))
                              },
                              expression: "item.arriveTimeMi"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c("el-input", {
                            attrs: { type: "number", min: 0, disabled: true },
                            model: {
                              value: item.repairedTimeMi,
                              callback: function($$v) {
                                _vm.$set(item, "repairedTimeMi", _vm._n($$v))
                              },
                              expression: "item.repairedTimeMi"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c("el-input", {
                            attrs: { type: "number", min: 0, disabled: true },
                            model: {
                              value: item.wrntPeriod,
                              callback: function($$v) {
                                _vm.$set(item, "wrntPeriod", _vm._n($$v))
                              },
                              expression: "item.wrntPeriod"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c("el-input", {
                            attrs: { type: "number", min: 0, disabled: true },
                            model: {
                              value: item.telCallTimeMi,
                              callback: function($$v) {
                                _vm.$set(item, "telCallTimeMi", _vm._n($$v))
                              },
                              expression: "item.telCallTimeMi"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { disabled: true },
                              model: {
                                value: item.timesLimitType,
                                callback: function($$v) {
                                  _vm.$set(item, "timesLimitType", $$v)
                                },
                                expression: "item.timesLimitType"
                              }
                            },
                            _vm._l(_vm.timesLimitTypeList, function(
                              timesLimitType
                            ) {
                              return _c("el-option", {
                                key: timesLimitType.value,
                                attrs: {
                                  disabled: true,
                                  label: timesLimitType.text,
                                  value: timesLimitType.value
                                }
                              })
                            })
                          ),
                          _vm._v(" "),
                          item.timesLimitType == 0
                            ? [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      prop:
                                        "contractServc2List." +
                                        index +
                                        ".quantity",
                                      rules: {
                                        validator: _vm.quantityCheck,
                                        trigger: "blur"
                                      }
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        type: "number",
                                        min: 0,
                                        disabled: !item.quantityRevisible
                                      },
                                      on: {
                                        change: function($event) {
                                          _vm.quantityChange(index, true)
                                        }
                                      },
                                      model: {
                                        value: item.quantity,
                                        callback: function($$v) {
                                          _vm.$set(
                                            item,
                                            "quantity",
                                            _vm._n($$v)
                                          )
                                        },
                                        expression: "item.quantity"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            : _vm._e()
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("td", [
                        _c(
                          "div",
                          {
                            staticClass: "swb-btn swb-btn-link",
                            on: {
                              click: function($event) {
                                _vm.setOrgSpecInfo(
                                  index,
                                  item.servcTypeId,
                                  item.timesLimitType,
                                  item.quantityRevisible,
                                  true
                                )
                              }
                            }
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  item.timesLimitType != 1
                                    ? "设置特定门店价格"
                                    : "设置门店次数和价格"
                                )
                              )
                            ])
                          ]
                        )
                      ])
                    ])
                  })
                )
              ])
            ]
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("合同信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("零售商名称")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("服务商")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("合同名称")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("系统合同编号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("起始时间")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", { staticClass: "required" }, [_vm._v("结束时间")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", { staticClass: "required" }, [_vm._v("发票类型")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("发票抬头")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("发票内容标签")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", { staticClass: "required" }, [_vm._v("纳税人识别号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("设备维保服务")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("常规服务请求")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1fe7082e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1fe7082e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/contract/ContractServcPurchModify.vue
// module id = 3241
// module chunks = 0